import { TabContext, TabList } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import { MobileIcon, TabletIcon, WindowIcon } from "@platformx/shared/static-assets";
import { ErrorTooltip, useAccess } from "@platformx/utilities";
import { useStyles } from "./PreviewTabsButton.styles";

const PreviewTabsButton = ({ handleChange, value, previewStatus, iconDisabled }) => {
  const classes = useStyles();
  const { canAccessAction } = useAccess();
  const canPreview = canAccessAction("Page", "sitepage", "preview");
  return (
    <Box className={classes.previewTabsButtons}>
      <TabContext value={value}>
        <ErrorTooltip
          component={
            <TabList
              TabIndicatorProps={{
                style: { display: "none" },
              }}
              onChange={handleChange}>
              <Tab
                icon={<img src={WindowIcon} alt='' />}
                value='window'
                disabled={!previewStatus || iconDisabled || !canPreview}
                className='Icon'
              />
              <Tab
                icon={<img src={TabletIcon} alt='' />}
                value='tablet'
                disabled={!previewStatus || iconDisabled || !canPreview}
                className='Icon'
              />
              <Tab
                icon={<img src={MobileIcon} alt='' />}
                value='mobile'
                disabled={!previewStatus || iconDisabled || !canPreview}
                className='Icon'
              />
            </TabList>
          }
          doAccess={!canPreview}
        />
      </TabContext>
    </Box>
  );
};

export default PreviewTabsButton;
